module.exports = __webpack_public_path__ + "assets/img/focusicon1.8bafd405.png";